export default __webpack_public_path__ + "static/media/alcryp.a40a9306.svg";